export const nonProdClientId = `stg-rio-global-web`
export const prodClientId = `rio-global-web`
export const nonProd_BP_BaseURL = `https://bp-stg-b2bid.bpglobal.com`
export const nonProd_Aral_BaseURL = `https://aral-stg-b2bid.bpglobal.com`
export const prod_BP_BaseURL = 'https://b2bid.bp.com'
export const prod_Aral_BaseURL = 'https://b2bid.aral.de'
export const azure_nonProdClientId = `9b20d726-1956-4a7b-bc5e-bfd6defec927`
export const azure_prodClientId = `5c5fc604-613d-4271-9a4b-dcc748eadf18`